import './styles/SvgFramesAnimator.scss';
import { useState, useRef, useEffect } from 'react';

const nonstate = {
    frameSpeedMultiplier: 1.5
}

interface Props {
    //animationName: string, ---deprecate to import frames on upper level
    frames: any[],
    frameCount: number,
    fps: number,
    repeat?: boolean
}

const SvgFramesAnimator: React.FC<Props> = ({ frames,/*animationName ---deprecated*/ frameCount, fps, repeat }) => {
    //states
    const [currentFrameNo, SetCurrentFrameNo] = useState(0);
    //refs
    // const framesRef = useRef<any[]>([] as any[]); ---deprecate to load in InstructionBox before everytime animation call
    const currentFrameNoRef = useRef(currentFrameNo);
    const animationIntervalRef = useRef<any>();

    //life cycle
    useEffect(() => {
        const Initialize = () => {
            //initialize framesRef
            //InitializeFrames();

            //load all frames
            //LoadAllFrames();

            //start frame animation
            animationIntervalRef.current = setInterval(() => {
                if (currentFrameNoRef.current < frameCount) {
                    currentFrameNoRef.current = currentFrameNoRef.current += 1;
                } else {
                    if (repeat)
                        currentFrameNoRef.current = 0;
                    else
                        clearInterval(animationIntervalRef.current);
                }
                SetCurrentFrameNo(currentFrameNoRef.current);
            }, (1000/nonstate.frameSpeedMultiplier) / fps);
        }

        Initialize();

        return (() => {
            clearInterval(animationIntervalRef.current);
        });
    }, []);

    // useEffect(() => {
    //     if(currentFrameNo >= frameCount) {
    //         console.log('animation finished!');
    //         if(repeat) {
    //             currentFrameNoRef.current = 0;
    //             SetCurrentFrameNo(currentFrameNoRef.current);
    //         }
    //         else {
    //             console.log('should clear interval');
    //             clearInterval(animationIntervalRef.current);
    //             animationIntervalRef.current = null;
    //         }
    //     }
    // }, [currentFrameNo]);

    //test
    // useEffect(() => {
    //     console.log('frameRefUpdated!: ' + JSON.stringify(frames));
    // }, [frames]);

    //parallel - exe functions
    // const InitializeFrames = async () => {
    //     const _frames = framesRef.current;
    //     for (let i = 0; i < frameCount; i++) {
    //         await _frames.push({});
    //     }
    //     framesRef.current = _frames;
    // }
    // const LoadAllFrames = async () => {
    //     console.log('svgFramesAnimator: IsLoadingFrames');
    //     for (let i = 0; i <= frameCount; i++) {
    //         const frameLabel = i < 10 ? ('0' + i.toString()) : i.toString();
    //         framesRef.current[i] = await import(`../assets/animations/${animationName + '/frame' + frameLabel + '.svg'}`);
    //     }
    // } ---deprecate to load frames from parent

    return (
        <img className='SvgFramesAnimator'
            src={
                frames[currentFrameNo] ? frames[currentFrameNo].default : ''
            }
        />
    )
}

export default SvgFramesAnimator;